type ValidationLikeError = {
  message?: unknown;
  property?: string;
  constraints?: Record<string, unknown>;
  children?: unknown[];
};

const flattenApiMessage = (value: unknown): string[] => {
  if (value === null || value === undefined) {
    return [];
  }

  if (typeof value === 'string') {
    const trimmedValue = value.trim();
    return trimmedValue ? [trimmedValue] : [];
  }

  if (Array.isArray(value)) {
    return value.flatMap((item) => flattenApiMessage(item));
  }

  if (typeof value === 'object') {
    const errorValue = value as ValidationLikeError;
    const directMessage = flattenApiMessage(errorValue.message);

    if (directMessage.length) {
      return directMessage;
    }

    const constraintMessages = Object.values(errorValue.constraints || {}).flatMap(
      (item) => flattenApiMessage(item),
    );

    if (constraintMessages.length) {
      return errorValue.property
        ? constraintMessages.map((message) => `${errorValue.property}: ${message}`)
        : constraintMessages;
    }

    const childMessages = (errorValue.children || []).flatMap((item) =>
      flattenApiMessage(item),
    );

    if (childMessages.length) {
      return childMessages;
    }

    try {
      return [JSON.stringify(value)];
    } catch {
      return [String(value)];
    }
  }

  return [String(value)];
};

const formatApiMessage = (value: unknown, fallback = '') => {
  const messages = [...new Set(flattenApiMessage(value).filter(Boolean))];

  if (messages.length) {
    return messages.join(', ');
  }

  return fallback;
};

export default formatApiMessage;
